import { useEffect } from 'react';

import type { CollabEditProvider } from '@atlaskit/editor-common/collab';

/** Connects explicit NCS recovery requests to the document's shared recovery callback. */
export const useRecoveryRequired = (
	collabEditProvider: CollabEditProvider | null,
	recover: () => Promise<void>,
): void => {
	useEffect(() => {
		if (!collabEditProvider) {
			return;
		}
		const handleRecoveryRequired = () => {
			void recover();
		};
		collabEditProvider.on('recovery:required', handleRecoveryRequired);
		return () => {
			collabEditProvider.off('recovery:required', handleRecoveryRequired);
		};
	}, [collabEditProvider, recover]);
};
